import { Tooltip } from "monday-ui-react-core";
import type { RefObject } from "react";
import React from "react";
import { useOverflowDetector } from "react-detectable-overflow";
import styled from "styled-components";

type BoardTextOverflowProps = React.PropsWithChildren<{ tooltip?: string }>;

const OverflowableLable = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const BoardLabelOverflow: React.FC<BoardTextOverflowProps> = ({ children, tooltip }) => {
  const { ref, overflow } = useOverflowDetector({});
  return (
    <OverflowableLable ref={ref as RefObject<HTMLSpanElement>}>
      {overflow ? (
        <Tooltip content={<React.Fragment>{tooltip || children}</React.Fragment>} containerSelector="body">
          <React.Fragment>{children}</React.Fragment>
        </Tooltip>
      ) : (
        <React.Fragment>{children}</React.Fragment>
      )}
    </OverflowableLable>
  );
};

export default BoardLabelOverflow;
